import { useCallback, useState } from 'react';
import { useAuthContext, useConfigContext } from '../../context';
import axios from 'axios';
import { DEFAULT_LOCATION, resolveLocationFromUrl } from '../../location';

const useSignpostData = () => {
  const { apiBaseUrl, featuresByLocation, locationByHost } = useConfigContext();
  const { locationId } = resolveLocationFromUrl({
    pathname: window.location.pathname,
    hostname: window.location.hostname,
    featuresByLocation,
    locationByHost,
    defaultLocation: DEFAULT_LOCATION,
  });
  const location = `/${locationId}`;
  const {
    tokenStore: { idToken },
  } = useAuthContext();
  const [dataVersion, updateDataVersion] = useState(0);

  axios.defaults.headers.common.Authorization = `${idToken}`;

  const retrieveSignpostData = useCallback(async () => {
    try {
      const { data } = await axios.get(`${apiBaseUrl}/conditions${location}`);
      return data || [];
    } catch (error) {
      console.error(error);
      throw error;
    }
  }, [apiBaseUrl, location]);

  const saveSignpostData = async (conditions: any) => {
    try {
      await axios.put(`${apiBaseUrl}/conditions${location}`, { data: conditions });
      updateDataVersion((v) => (v += 1));
    } catch (error) {
      console.error(error);
    }
  };

  return { retrieveSignpostData, saveSignpostData, dataVersion };
};

export { useSignpostData };
